import React, { useEffect, useState } from 'react';
import {browserHistory, Link} from 'react-router';
import PropTypes from "prop-types";
import moment from 'moment';
import util from '../util/util';
import Tooltip from "../tooltip/tooltip";

export default function PodDetailRules (props) {
  const tooltipMessage = "Only successfully ingested pods<br />can be added to a rule.";

  const [podId, setPodId] = useState(0);
  const [podStatus, setPodStatus] = useState(1);
  const [rules, setRules] = useState([]);

  useEffect( ()=>{
    setPodId(props.podId);
    setPodStatus(props.podStatus);
    setRules(props.rules.slice(0, 5))
  }, [props.podId, props.podStatus, props.rules]);

  // set the rules to display equal to the full list of rules;
  const showAll = () => {
    setRules(props.rules)
  }

  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__header">Rules</h4>
        </div>
        <div className="col-xs-6">
          <p className="page__actions">
            <span
              data-tip={podStatus !== 2 ? tooltipMessage : ""}
              data-for="podRuleAddPodToRule"
            >
              <button
                className="btn btn-primary"
                disabled={podStatus !== 2 ? true : ""}
                onClick={podStatus !== 2 ? () => {return "";} : () => browserHistory.push(
                  util.returnRuleFormUrl(0, podId)
                )}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                Add to New Rule
              </button>
            </span>
          </p>
          {podStatus !== 2 && <Tooltip id="podRuleAddPodToRule" />}
        </div>
      </div>

      <hr />

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={ { width: `1%` } }></col>
            <col style={ { width: `39%` } }></col>
            <col style={ { width: `15%` } }></col>
            <col style={ { width: `15%` } }></col>
            <col style={ { width: `15%` } }></col>
            <col style={ { width: `15%` } }></col>
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>Rule</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Time Slots / Shows</th>
              <th>Repeats</th>
            </tr>
          </thead>
          <tbody>
            {
              rules.length === 0 ? (
                <tr>
                  <td><strong>0</strong></td>
                  <td colSpan="5"><em>None</em></td>
                </tr>
              ) : (
                rules.map((rule, index) => {
                  const cleanedTimeSlots = util.returnCleanTimeSlots(rule.timeslots);

                  return (
                    <tr key={ rule.id }>
                      <td><strong>{ index + 1 }</strong></td>
                      <td><Link to={ util.returnRuleDetailUrl(rule.id) }>{ rule.name }</Link></td>
                      <td>{ moment(rule.start_date).format(util.dateFormatHumanLong) }</td>
                      <td>{ moment(rule.end_date).format(util.dateFormatHumanLong) }</td>
                      <td>
                        {rule.timeslots && rule.timeslots.length > 0 ? (
                          <span
                            className="timeslots-cell"
                            title={ cleanedTimeSlots.join(`, `) }
                          >
                            { cleanedTimeSlots.join(`, `) }
                          </span>
                        ) : null}
                        {rule.shows && rule.shows.length > 0
                          ? util.renderShowsNames(rule.shows)
                          : null}
                      </td>
                      <td>{ util.returnRepeatValue(rule.frequency) }</td>
                    </tr>
                  );
                })
              )
            }
          </tbody>
        </table>
      </div>
      {
        rules && props.rules && rules.length !== props.rules.length ? (
          <p className="text-center">
            <button
              id="pod-detail-rules__show-all"
              className="btn btn-default"
              onClick={ () => showAll() }>
              Show All { props.rules.length } Rules
            </button>
          </p>
        ) : null
      }
    </div>
  );
}

PodDetailRules.propTypes = {
  podId: PropTypes.number,
  podStatus: PropTypes.number,
  rules: PropTypes.array
};
